"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
var _categoryApi = require("@/api/categoryApi");
function list() {
  return (0, _categoryApi.treeCategroy)({
    type: 1,
    status: -1
  });
}